import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface ChipDropdownItem {
  label: string;
  quantity?: string;
  value: string;
}

export interface ChipDropdownSection {
  title: string;
  items: ChipDropdownItem[];
}

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.less']
})
export class ChipComponent implements OnInit {
  activeChip = false;
  @Input() chipLabel: string;
  @Input() chipDescription: string;
  @Input() disabled: false;
  @Input() variant: 'dropdown' | 'checkbox';
  @Input() chipValue: string | {};
  @Output() onChipClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChipDropdownItemsClick: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Input() chipDropdownItems: ChipDropdownSection[];

  // Use it only if you want to give custom color from default
  @Input() iconColor: string;
  @Input() iconColorSelected: string;

  constructor() { }

  ngOnInit(): void {
  }

  chipClicked(chipValue): void {
    this.onChipClick.emit(chipValue);
  }

  toggleActive() {
    this.activeChip = !this.activeChip;
  }

  getClass() {
    return this.activeChip ? 'active-chip' : 'inactive-chip';
  }

  chipDropdownChanged(value: string[]): void {
    value.length > 0 ? this.activeChip = true : this.activeChip = false;
    this.onChipDropdownItemsClick.emit(value);
  }
}
